import { TaskOutcome } from '@/services/ws-funnel/src/main/resources/rest-api';

export const PossibleOutcomes = [TaskOutcome.DUPLICATE, TaskOutcome.NO_POTENTIAL, TaskOutcome.AGED];
